<template>
  <footer class="plus_border">
    <div class="container margin_30">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <h3
            data-toggle="collapse"
            data-target="#collapse_ft_1"
          >
            {{ $t('lang.footer.links_title') }}
          </h3>
          <div
            id="collapse_ft_1"
            class="collapse dont-collapse-sm"
          >
            <ul class="links">
              <li>
                <a
                  :href="`/help/${this.$store.state.main.lang}`"
                  target="_blank"
                >{{ $t('lang.titles.help') }}</a>
              </li>
              <li>
                <a
                  href="/register"
                >{{ $t('lang.footer.register') }}</a>
              </li>

              <li>
                <a
                  href="/terms-and-conditions#tyc"
                  target="_blank"
                >{{ $t('lang.forms.terms_and_conditions_link') }}</a>
              </li>
              <li>
                <a
                  href="/terms-and-conditions#privacy"
                  target="_blank"
                >{{ $t('lang.forms.privacy_policy_link') }}</a>
              </li>
              <li>
                <a
                  href="https://store.wekeep.app/"
                  target="_blank"
                >{{ $t('lang.footer.stores') }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div
          id="footer_cities_list"
          class="col-lg-6 col-md-6 col-sm-6"
        >
          <h3
            data-toggle="collapse"
            data-target="#collapse_ft_2"
          >
            {{ $t('lang.footer.cities_title') }}
          </h3>
          <div
            v-for="(country) in countriesList"
            id="collapse_ft_2"
            :key="country.id"
            class="collapse dont-collapse-sm "
          >
            <p class="mb-1">
              <b>{{ country.icon +' | '+ $t(`lang.countries.${country.id}`) }} </b>
            </p>
            <div>
              <ul class="links pt-0 two-columns-always">
                <li
                  v-for="(city, index) in citiesList(country.id)"
                  :key="index"
                >
                  <b-link :href="'/'+$t('lang.city_home.path')+'/'+city.id">
                    {{ city.name }}
                  </b-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <h3
            data-toggle="collapse"
            data-target="#collapse_ft_3"
          >
            {{ $t('lang.footer.contact_title') }}
          </h3>
          <div
            id="collapse_ft_3"
            class="collapse dont-collapse-sm"
          >
            <p class="mb-3">
              <span v-if="this.$store.state.main.currency === 'ARS'">WeKeep Argentina</span>
              <span v-else>WeKeep Travel Services LLC</span>
            </p>
            <ul class="contacts">
              <li v-if="this.$store.state.main.currency === 'ARS'">
                <i class="ti-home" />Argentina
              </li>
              <li v-else>
                <i class="ti-home" />DE, USA
              </li>
              <li><i class="ti-headphone-alt" />+54 11 3288 4589</li>
              <li><i class="ti-email" /><a href="mailto:info@wekeep.app">info@wekeep.app</a></li>
            </ul>
          </div>
          <h3 class="not-collapse mb-2">
            {{ $t('lang.footer.follow_us') }}
          </h3>
          <div class="follow_us">
            <ul>
              <li>
                <a
                  href="https://www.facebook.com/app.wekeep"
                  target="_blank"
                  aria-label="Facebook"
                ><i class="fab fa-facebook-f" /></a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/wekeep.app"
                  target="_blank"
                  aria-label="Instagram"
                ><i class="fab fa-instagram" /></a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@wekeep.app"
                  target="_blank"
                  aria-label="TikTok"
                ><i class="fab fa-tiktok" /></a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/wekeep-app"
                  target="_blank"
                  aria-label="Linkedin"
                ><i class="fab fa-linkedin-in" /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 text-center">
          <ul id="additional_links">
            <li>
              <span>
                © WeKeep {{ (new Date()).getFullYear() }} |
                {{ $t('lang.footer.rights') }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { cities } from '../data/cities';
import countries from '../data/countries';
import '../assets/css/icon_fonts/fontawesome/css/all.min.css';

export default {
  name: 'Footer',
  data() {
    return {
      searchParams: {
        place: null,
        input_start_date: '',
        input_end_date: '',
        bags_number: 2,
      },
    };
  },
  computed: {
    countriesList() {
      const list = [];
      let countryData = [];
      countries.forEach((country) => {
        countryData = country;
        countryData.name = this.$t(`lang.countries.${country.id}`);
        list.push(countryData);
      });
      list.sort((a, b) => a.name.localeCompare(b.name));
      return list;
    },
  },
  methods: {
    citiesList(country) {
      const list = [];
      let cityData = [];
      cities.forEach((city) => {
        if (city.country === country) {
          cityData = city;
          cityData.name = this.$t(`lang.cities.${city.id}`);
          list.push(cityData);
        }
      });
      // sorted alphabetically by name
      list.sort((a, b) => a.name.localeCompare(b.name));

      return list;
    },

    citySelected(selectedCity) {
      const cityData = cities.find((data) => data.id === selectedCity);

      if (this.$route.name === 'Home') {
        this.$emit('selectedCity', selectedCity);
      } else {
        if (this.$store.state.search.searchParams != null) {
          this.searchParams = this.$store.state.search.searchParams;
        }

        this.searchParams.place = { geometry: cityData.geometry, formatted_address: this.$t(`lang.cities.${cityData.id}`) };
        this.$store.dispatch('setSearchParams', this.searchParams);

        this.$router.push('/');
      }
    },
  },
};
</script>
